/**
 * Modèle pour le paramétrage des adresses des internes
 */
export class InternesParams {
    /** Autoriser la saisie d'adresse personnelle par les collaborateurs */
    autoriserAdressePerso: boolean = true;

    /** Autoriser la saisie d'adresse professionnelle par les collaborateurs */
    autoriserAdressePro: boolean = true;
}